import * as React from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {Button, getAllThemes, setTheme, DefaultThemeContext} from '@openfin/desktop-ui';

import {LaunchAdminWindow, Authenticated} from '../../../../store/partials/Authentication';
import {RootState} from '../../../../store/State';
import {Option, OptionSelector, OptionSelectorProps} from '../../../components/OptionSelector/OptionSelector';
import {SetLaunchBarDocked} from '../../../../store/partials/Settings';

import * as Styles from './LaunchBarSettings.module.scss';

interface Props {
    docked: boolean;
    isAdmin: boolean;
    launchAdminWindow: () => void;
    setLaunchBarDocked: (docked: boolean) => void;
    logout: () => void;
}

const LaunchBarSettingsComponent: React.FC<Props> = (props) => {
    const {docked, isAdmin, launchAdminWindow, setLaunchBarDocked, logout} = props;
    const {theme} = React.useContext(DefaultThemeContext);
    const allThemes = Object.values(getAllThemes());

    const showAdminPanel = () => {
        launchAdminWindow();
    };

    const optionSelectors: OptionSelectorProps[] = [
        {
            choices: [{key: 'FLOAT', label: 'Floating'}, {key: 'DOCK', label: 'Docked to Top'}],
            label: 'Mode',
            onChange: (option: Option) => setLaunchBarDocked(option.key === 'DOCK'),
            selectedChoiceKey: docked ? 'DOCK' : 'FLOAT'
        },
        {
            choices: allThemes.map((availableTheme) => ({key: availableTheme.id, label: availableTheme.name, data: availableTheme})),
            label: 'Theme',
            onChange: (option: Option) => setTheme(option.data, true),
            selectedChoiceKey: theme.current!.id
        }
    ];

    return (
        <div className={Styles['settings']}>
            {optionSelectors.map((option, i) => <OptionSelector
                key={i}
                label={option.label}
                choices={option.choices}
                selectedChoiceKey={option.selectedChoiceKey}
                onChange={option.onChange}
            />)}

            <div className={Styles['buttons']}>
                {isAdmin && <Button block onClick={showAdminPanel}>Open Admin Panel</Button>}
                <Button block onClick={logout}>Logout</Button>
            </div>
        </div>
    );
};

const mapState = (state: RootState) => ({
    docked: state.settings.launcherDocked,
    isAdmin: state.authentication.account.isAdmin
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    launchAdminWindow: () => dispatch(new LaunchAdminWindow()),
    setLaunchBarDocked: (docked: boolean) => dispatch(new SetLaunchBarDocked(docked)),
    logout: () => dispatch(new Authenticated(false))
});

export const LaunchBarSettings = connect(mapState, mapDispatchToProps)(LaunchBarSettingsComponent);
